export default {"src":"/_next/static/media/unhappyInactive_24.f10cf62c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};